<template>
    <!-- TODO css -->
    <modal @close="modals.giftRegistrationNoteModal = false">
        <div v-if="screen === 'form'">
            <h3>Edit Note</h3>        
            <form @submit.prevent class="large-form">
                <div class="form-line" >
                    <div class="form-field">
                        <label>Gift Recipient</label>
                        <div v-if="registration.last_name" class="form-static-field">{{ registration.first_name }} {{ registration.last_name }}</div>
                        <div v-else class="form-static-field">{{ registration.email }}</div>
                    </div>
                    <div v-if="registration.option_name" class="form-field">
                        <label>Gift Option</label>
                        <div class="form-static-field">{{ registration.option_name }}</div>
                    </div>
                </div>
                <div class="form-line">
                    <div class="form-field form-field-textarea">
                        <label>Note</label>
                        <textarea v-model="note.text" placeholder="Write your internal team notes here." rows="6" maxlength="1015"></textarea>
                        <div style="text-align: left;" v-if="note.by && note.date">Last updated by <b>{{ note.by }}</b> on <i>{{ note.date }}</i>.</div>
                    </div>
                </div>
                
                
                
                <div class="modal-errors">
                    <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
                </div>                  
            </form>
        
            <div class="form-actions">
                <div class="ws-button ws-button-secondary" data-action="cancel" @click="modals.giftRegistrationNoteModal = false">Cancel</div>
                <div class="ws-button ws-button-main" @click="submit">Save Changes</div>
            </div>
      </div>

      <!-- Order Prgcessing -->
      <div v-else-if="screen === 'processing'">
          <div class="ws-form-processing"><div class="value-loader"></div><p>We are saving your note. <br>Please give us a moment...</p></div>
      </div>
      
      <!-- Loading -->
      <div v-else-if="screen === 'loading'">
          <div class="ws-form-processing"><div class="value-loader"></div><p>We're retrieving your gift registration.</p></div>
      </div>
      
  </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "GiftRegistrationNoteModal",
    components: {Modal},
    props: {
        registrationId: Number,
    },
    data() {
        return {
            screen: 'loading',
            note: {text: '', date: null, by: null},
            errors: {},
            registration: null,
        }
    },
    methods: {
        async submit() {
            if (!this.demoCheck()) return;
            this.screen = 'processing';
            this.registration = await this.dispatchWaitAndNotify('updateGiftBoxRegistration', {registrationId: this.registrationId, payload: {'action':'note-update','note':this.note.text}}, false, true);
            this.note = this.registration.note;
            this.screen = 'form';
        },
    },
    async mounted() {
        this.registration = await this.dispatchWaitAndNotify('fetchGiftBoxRegistration', {registrationId: this.registrationId}, false, true);
        this.note = this.registration.note;
        this.screen = 'form';
    },
    computed: {
        user() {
            return this.$store.state.currentUser;
        },
        campaign() {
            return this.$store.state.giftBoxCampaign.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
    },
    watch: {
        
	}
}
</script>

<style scoped>

</style>